import Header from "../components/Header";
import MainContainer from "../components/MainContainer";

const Home = () => {
  return (
    <div className="flex flex-col h-screen ">
      <Header />
      <MainContainer />
    </div>
  );
};
export default Home;
